import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpRequestService} from '../../../shared/services/http-request.service';

@Injectable()
export class AddNewCoverService {
  getMembersUrl = environment.apiUrl + '/MemberCms/GetMembersForNewCover';
  constructor(private http: HttpRequestService) { }

  getMembers() {
    return this.http.get(this.getMembersUrl);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/venues/venue-details/add-new-cover/add-new-cover.service.ts